import { SORT_TYPES } from '../constants/sort';

export const getGroupRequestQueryParams = (parsedSearchParams) => {
    const queryParams = { ordering: parsedSearchParams.sort || SORT_TYPES.alphabetical };

    if (parsedSearchParams.search) {
        queryParams.search = parsedSearchParams.search;
    }

    return queryParams;
};
